// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	production: false,
	//API_URL: "http://localhost:23091/", //DEVELOPMENT
	imzaConnectorUrl: "https://edefter.ardsistem.com.tr/download/EDefterSetup.exe",
	//API_URL: "http://edefterapitest.turkfatura.com.tr/" //TEST SUNUCU
	API_URL: "https://api.turkdefter.com.tr/" //CANLI SUNUCU !!

};
